// Templatizzazione dei path HTTP per il grouping delle metriche: gli id
// variabili (uuid, run numeriche) diventano placeholder, così richieste alla
// stessa rotta condividono la signature. Parità con `NetHTTPPatch` (gem) e
// `dio_interceptor` (dart): uuid→`<uuid>`, run ≥3 cifre→`<n>`.

const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi
const LONG_NUMBER_RE = /\d{3,}/g

export function templatizePath(path: string): string {
  return path.replace(UUID_RE, '<uuid>').replace(LONG_NUMBER_RE, '<n>')
}
